type FlightDealPrices = Pick<App.FlightDeal, 'perAdultPrice' | 'luxPlusPerAdultPrice'>

export function getFlightDealMemberPrice(deal: FlightDealPrices): number | undefined {
  const { perAdultPrice, luxPlusPerAdultPrice } = deal
  if (typeof luxPlusPerAdultPrice === 'number' && Number.isFinite(luxPlusPerAdultPrice)
    && Number.isFinite(perAdultPrice) && luxPlusPerAdultPrice > 0 && luxPlusPerAdultPrice < perAdultPrice) {
    return luxPlusPerAdultPrice
  }
  return undefined
}
